import {
  getProducts,
  getProduct,
  getGroupProducts,
  getReviews,
  getQuestions,
} from '../api';

export const productApi = {
  /**
   * Поиск товаров с фильтрами, пагинацией и сортировкой.
   * @param {Object} params - { page, limit, sort, category, subcategory, brand, size, color, min_price, max_price, search }
   * @returns {Promise<{ products: Array, total: number }>}
   */
  search: (params) =>
    getProducts(params).then(res => {
      const data = res.data;
      if (data && data.products) return data; // { products, total }
      if (Array.isArray(data)) return { products: data, total: data.length };
      return { products: [], total: 0 };
    }),
  getById: (id) => getProduct(id).then(res => res.data),
  getGroup: (groupId) => getGroupProducts(groupId).then(res => res.data),
  getReviews: (productId) => getReviews(productId).then(res => res.data),
  getQuestions: (productId) => getQuestions(productId).then(res => res.data),
};